<template>
  <div>
    <page-main
      :tableData="data"
      :loading="loading"
      :disabled="disabled"
      @reload="refresh"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @openEditPage="openEditPage"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [BaseTable],
  props: {
    evgPlanOrderCode: { type: String, default: '' },
    data: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  components: { PageMain, PageHeader },
  data() {
    return {
      editOptions: {
        visible: false,
        type: 'edit',
      },
    }
  },
  methods: {
    openEditPage({ type, code }) {
      this.editOptions = {
        visible: true,
        type: type,
        code: code,
      }
    },
    async getData(form) {
      this.loading = true
      // const res = await this.$api.xx({ ...form }).catch(() => null)
      this.loading = false
      //    if (!res) return
      // this.tableData = res.body.data
    },
    refresh() {
      this.reload()
      this.$emit('refresh')
    },
  },
}
</script>
